import { Navigate } from 'react-router-dom';
import {
  AccountBalanceWallet,
  AddShoppingCart,
  AddToQueue,
  AttachMoney,
  ContactMail,
  Dashboard,
  LocalShipping,
  People,
  RemoveShoppingCart,
  ShoppingBasket,
  ShoppingCart
} from '@material-ui/icons';

import Admin from 'views/Admin';
import MainPage from 'views/MainPage';
import DashboardPage from 'views/Dashboard';
import QuickSale from 'views/QuickSale';
import SalesOrderList from 'views/SalesOrderList';
import CustomerList from 'views/CustomerList';
import ProductList from 'views/ProductList';
import EmployeeList from 'views/EmployeeList';
import VendorList from 'views/VendorList';
import PurchaseOrderList from 'views/PurchaseOrderList';
import ReturnOrderList from 'views/ReturnOrderList';
import ExpenseList from 'views/ExpenseList';
import Accounts from 'views/Accounts';

import NotFound from 'views/NotFound';
import Login from 'views/Login';

export const LoggedInSingleRoutes = [
  {
    path: "app",
    element: <Admin />,
    children: [
      { path: "dashboard", element: <DashboardPage /> },
      { path: "quickSale", element: <QuickSale /> },
      { path: "salesOrders", element: <SalesOrderList /> },
      { path: "customers", element: <CustomerList /> },
      { path: "products", element: <ProductList /> },
      { path: "employees", element: <EmployeeList /> },
      { path: "vendors", element: <VendorList /> },
      { path: "purchaseOrders", element: <PurchaseOrderList /> },
      { path: "returnOrders", element: <ReturnOrderList /> },
      { path: "expenses", element: <ExpenseList /> },
      { path: "accounts", element: <Accounts /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  },
  {
    path: "",
    element: <MainPage />,
    children: [
      { path: "login", element: <Login /> },
      { path: "404", element: <NotFound /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  }
];

export const LoggedInAdminRoutes = [
  {
    path: "app",
    element: <Admin />,
    children: [
      { path: "dashboard", element: <DashboardPage /> },
      { path: "salesOrders", element: <SalesOrderList /> },
      { path: "customers", element: <CustomerList /> },
      { path: "products", element: <ProductList /> },
      { path: "employees", element: <EmployeeList /> },
      { path: "vendors", element: <VendorList /> },
      { path: "purchaseOrders", element: <PurchaseOrderList /> },
      { path: "returnOrders", element: <ReturnOrderList /> },
      { path: "expenses", element: <ExpenseList /> },
      { path: "accounts", element: <Accounts /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  },
  {
    path: "",
    element: <MainPage />,
    children: [
      { path: "login", element: <Login /> },
      { path: "404", element: <NotFound /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  }
];

export const LoggedInStandardRoutes = [
  {
    path: "app",
    element: <Admin />,
    children: [
      { path: "dashboard", element: <DashboardPage /> },
      { path: "quickSale", element: <QuickSale /> },
      { path: "salesOrders", element: <SalesOrderList /> },
      { path: "customers", element: <CustomerList /> },
      { path: "products", element: <ProductList /> },
      { path: "expenses", element: <ExpenseList /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  },
  {
    path: "",
    element: <MainPage />,
    children: [
      { path: "login", element: <Login /> },
      { path: "404", element: <NotFound /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  }
];

export const LoggedOutRoutes = [
  {
    path: "app",
    element: <Admin />,
    children: [
      { path: "dashboard", element: <DashboardPage /> },
      { path: "quickSale", element: <QuickSale /> },
      { path: "salesOrders", element: <SalesOrderList /> },
      { path: "customers", element: <CustomerList /> },
      { path: "products", element: <ProductList /> },
      { path: "employees", element: <EmployeeList /> },
      { path: "vendors", element: <VendorList /> },
      { path: "purchaseOrders", element: <PurchaseOrderList /> },
      { path: "returnOrders", element: <ReturnOrderList /> },
      { path: "expenses", element: <ExpenseList /> },
      { path: "accounts", element: <Accounts /> },
      { path: "", element: <Navigate to="/app/dashboard" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  },
  {
    path: "",
    element: <MainPage />,
    children: [
      { path: "login", element: <Login /> },
      { path: "404", element: <NotFound /> },
      { path: "", element: <Navigate to="/login" /> },
      { path: "*", element: <Navigate to="/404" /> }
    ]
  }
];

export const singleRouteNames = [
  { href: "/app/dashboard", name: "Dashboard", icon: Dashboard },
  { href: "/app/quickSale", name: "Quick Sale", icon: AddToQueue },
  { href: "/app/salesOrders", name: "Sales Orders", icon: ShoppingCart },
  { href: "/app/customers", name: "Customers", icon: People },
  { href: "/app/products", name: "Products", icon: ShoppingBasket },
  { href: "/app/employees", name: "Employees", icon: ContactMail },
  { href: "/app/vendors", name: "Vendors", icon: LocalShipping },
  { href: "/app/purchaseOrders", name: "Purchase Orders", icon: AddShoppingCart },
  { href: "/app/returnOrders", name: "Return Orders", icon: RemoveShoppingCart },
  { href: "/app/expenses", name: "Expenses", icon: AttachMoney },
  { href: "/app/accounts", name: "Accounts", icon: AccountBalanceWallet }
];

export const adminRouteNames = [
  { href: "/app/dashboard", name: "Dashboard", icon: Dashboard },
  { href: "/app/salesOrders", name: "Sales Orders", icon: ShoppingCart },
  { href: "/app/customers", name: "Customers", icon: People },
  { href: "/app/products", name: "Products", icon: ShoppingBasket },
  { href: "/app/employees", name: "Employees", icon: ContactMail },
  { href: "/app/vendors", name: "Vendors", icon: LocalShipping },
  { href: "/app/purchaseOrders", name: "Purchase Orders", icon: AddShoppingCart },
  { href: "/app/returnOrders", name: "Return Orders", icon: RemoveShoppingCart },
  { href: "/app/expenses", name: "Expenses", icon: AttachMoney },
  { href: "/app/accounts", name: "Accounts", icon: AccountBalanceWallet }
];

export const standardRouteNames = [
  { href: "/app/dashboard", name: "Dashboard", icon: Dashboard },
  { href: "/app/quickSale", name: "Quick Sale", icon: AddToQueue },
  { href: "/app/salesOrders", name: "Sales Orders", icon: ShoppingCart },
  { href: "/app/customers", name: "Customers", icon: People },
  { href: "/app/products", name: "Products", icon: ShoppingBasket },
  { href: "/app/expenses", name: "Expenses", icon: AttachMoney }
];